import { FeatureNameEnum } from './../../shared/feature/feature-name.enum';
import { FeatureService } from './../../shared/feature/feature.service';
import { SecurityElementNames } from './../../shared/auth/constants/security-element-names.service';
import { DropSettingsSimple } from './../shared/model/drop-settings-simple.model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ProfileService } from '../shared/profile.service';
import { ProfileRead } from '../shared/profile-read.model';
import { NavigationService } from '../../shared/navigation/navigation.service';
import { ListingService } from '../../listing/shared/listing.service';
import { UserService } from '../../users/shared/user.service';
import { TranslationService } from '../../shared/translation/translation.service';
import { MembershipLevelService } from '../../membership-level/shared/membership-level.service';
import { MemberService } from '../../member/shared/member.service';
import { SocialMedia } from '../shared/social-media.model';
import { ProfileDropMemberService } from '../shared/profile-drop-member.service';
import { DropMemberResult } from '../shared/model/drop-member-result.model';
import { MemberActivityTypeModel } from './../../member/shared/member-activity-type.model';
import { DropMembershipSettings } from 'src/app/member/shared/drop-membership-setttings.model';
import { NotificationService, UtilService } from 'src/app/shared';
import { ObservationService } from './../../shared/observation/observation.service';
import { ProfileViewPrimaryRelationsComponent } from './primary-relations/primary-relations.component';
import { CertificationTypeService } from 'src/app/certification/shared/certification-type.service';
import { Title } from '@angular/platform-browser';
import { VoterVoiceService } from 'src/app/integrations/voter-voice/shared/voter-voice.service';
import { VoterVoiceSettingsDto } from 'src/app/integrations/voter-voice/shared/voter-voice-settings.dto';

@Component({
  selector: 'wl-profile-view',
  templateUrl: 'profile-view.component.html',
  styleUrls: ['profile-view.component.less'],
  providers: [ProfileService],
  standalone: false,
})
export class ProfileViewComponent implements OnInit {
  @ViewChild(ProfileViewPrimaryRelationsComponent) private _relationsComponent: ProfileViewPrimaryRelationsComponent;

  // #region Services
  private _route: ActivatedRoute;
  private _navigationService: NavigationService;
  private _profileService: ProfileService;
  private _listingService: ListingService;
  private _userService: UserService;
  private _translationService: TranslationService;
  private _membershipLevelService: MembershipLevelService;
  private _memberService: MemberService;
  private _socialMedias: Array<SocialMedia>;
  private _dropMemberServcice: ProfileDropMemberService;
  private _notificationService: NotificationService;
  private _observationService: ObservationService;
  // #endregion

  public profileId: number = 0;
  public profile: ProfileRead;
  public profiles: Array<ProfileRead>;
  public listingCategory: string;
  public soldBy: string;
  public assignedTo: string;
  public membershipLevel: string;
  public memberSince: Date;

  // #region SocialMedia
  public facebook: SocialMedia;
  public twitter: SocialMedia;
  public linkedIn: SocialMedia;
  public pinterest: SocialMedia;
  public youTube: SocialMedia;
  public flickr: SocialMedia;
  public yelp: SocialMedia;
  public openTable: SocialMedia;
  public instagram: SocialMedia;
  public foursquare: SocialMedia;
  public tripAdvisor: SocialMedia;
  public houzz: SocialMedia;
  public angiesList: SocialMedia;
  // #endregion

  public showDropModal = false;
  public showAddModal = false;
  public autoDrop: boolean;
  public memberActivityTypes: Array<MemberActivityTypeModel>;
  public dropSettings: DropMembershipSettings;
  public selectedDropType: MemberActivityTypeModel;
  public disableAddMember = false;
  public hideRevenueCard = true;
  public showCertifications = false;
  public hasSalesOpportunities = false;
  voterVoiceSettings = {} as VoterVoiceSettingsDto;

  public constructor(
    route: ActivatedRoute,
    navigationService: NavigationService,
    profileService: ProfileService,
    listingService: ListingService,
    userService: UserService,
    translationService: TranslationService,
    membershipLevelService: MembershipLevelService,
    memberService: MemberService,
    dropMemberService: ProfileDropMemberService,
    notificationService: NotificationService,
    observationService: ObservationService,
    private _voterVoiceService: VoterVoiceService,
    public securityElementNames: SecurityElementNames,
    private _utilService: UtilService,
    private _certificationTypeService: CertificationTypeService,
    private _featureService: FeatureService,
    private _title: Title
  ) {
    this._route = route;
    this._navigationService = navigationService;
    this._profileService = profileService;
    this._listingService = listingService;
    this._userService = userService;
    this._translationService = translationService;
    this._membershipLevelService = membershipLevelService;
    this._memberService = memberService;
    this._dropMemberServcice = dropMemberService;
    this._notificationService = notificationService;
    this._observationService = observationService;

    this.profile = new ProfileRead();
    this._socialMedias = new Array<SocialMedia>();
    this.membershipLevel = '';
    this.memberActivityTypes = new Array<MemberActivityTypeModel>();
  }

  ngOnInit() {
    this._route.params.subscribe((id) => {
      this.profileId = parseInt(id['id'], 10);
      this.loadProfile(true);

      this._route.queryParams.subscribe((params: Params) => {
        if (params && this._utilService.getObjectPropertyValueCaseInsensitive(params, 'addMember')) {
          this.showAddModal = true;
        }
      });

      //this._observationService.profileUpdated(this.profileId);
    });
    this._memberService.getDropMembershipSettings().then((settings: DropMembershipSettings) => {
      this.dropSettings = settings;

      if (this.dropSettings) {
        this.autoDrop = true;
      }

      this._memberService.getMemberActivityDropCodes().then((types: Array<MemberActivityTypeModel>) => {
        this.memberActivityTypes = types;

        if (this.dropSettings.DropMemberActivityCode) {
          this.selectedDropType = this.memberActivityTypes.find((x) => x.ActivityTypeID == this.dropSettings.DropMemberActivityCode);
        }
      });
    });

    this._userService.getCurrentUserSecurityElementAccessLevel('Set_Profile_As_Member').then((accessLevel: number) => {
      this.disableAddMember = accessLevel <= 1;
    });

    this._userService.getCurrentUserSecurityElementAccessLevel('Revenue_Module').then((accessLevel: number) => {
      if (accessLevel > 0) {
        this.hideRevenueCard = false;
      }
    });

    this._certificationTypeService.areCertificationsEnabled().then((data: boolean) => {
      this.showCertifications = data;
    });

    this._featureService.has(FeatureNameEnum.SalesOpportunities).then((hasIt) => {
      this.hasSalesOpportunities = hasIt ?? false;
    });

    this._voterVoiceService.getVoterVoiceSettings().then((data) => {
      this.voterVoiceSettings = data;
    });
  }

  public loadProfile(forceRefresh?: boolean) {
    this._profileService.getProfile(this.profileId, forceRefresh).then((data: ProfileRead) => {
      this.profile = data;
      this._title.setTitle(data.ReportName);
      if (!this.profile.MembershipLevelId) {
        this._translationService.getTitlecase('profiles.view.general.no-membership-level').then((data: string) => {
          this.membershipLevel = data;
        });
      } else {
        this._membershipLevelService
          .getMembershipLevelName(this.profile.MembershipLevelId ? this.profile.MembershipLevelId : 0)
          .then((mL: string) => {
            this.membershipLevel = mL;

            if (!this.membershipLevel) {
              this._translationService.getTitlecase('profiles.view.general.no-membership-level').then((data: string) => {
                this.membershipLevel = data;
              });
            }
          });
      }
      this._memberService.getMemberSinceDate(this.profileId).then((memberSince: Date) => {
        this.memberSince = memberSince;
      });

      this._userService.getUserFullName(this.profile.SoldBy).then((sB: string) => {
        this.soldBy = sB;
      });

      this._userService.getUserFullName(this.profile.AssignedTo).then((aT: string) => {
        this.assignedTo = aT;
      });

      this._profileService.getProfileSocialMediaInfo(this.profileId).then((sM: Array<SocialMedia>) => {
        this._socialMedias = sM;

        this.facebook = this._socialMedias.filter((x) => x.SocialMediaTypeID == 101)[0];
        this.twitter = this._socialMedias.filter((x) => x.SocialMediaTypeID == 102)[0];
        this.linkedIn = this._socialMedias.filter((x) => x.SocialMediaTypeID == 103)[0];
        this.pinterest = this._socialMedias.filter((x) => x.SocialMediaTypeID == 104)[0];
        this.youTube = this._socialMedias.filter((x) => x.SocialMediaTypeID == 107)[0];
        this.flickr = this._socialMedias.filter((x) => x.SocialMediaTypeID == 108)[0];
        this.yelp = this._socialMedias.filter((x) => x.SocialMediaTypeID == 110)[0];
        this.openTable = this._socialMedias.filter((x) => x.SocialMediaTypeID == 111)[0];
        this.instagram = this._socialMedias.filter((x) => x.SocialMediaTypeID == 113)[0];
        this.foursquare = this._socialMedias.filter((x) => x.SocialMediaTypeID == 114)[0];
        this.tripAdvisor = this._socialMedias.filter((x) => x.SocialMediaTypeID == 115)[0];
        this.houzz = this._socialMedias.filter((x) => x.SocialMediaTypeID == 116)[0];
        this.angiesList = this._socialMedias.filter((x) => x.SocialMediaTypeID == 117)[0];
      });
    });

    this._listingService.getPrimaryListingCategoryForProfileId(this.profileId).then((category: string) => {
      this.listingCategory = category == '""' ? null : category;
    });
  }

  public findProfiles = (): void => {
    this._navigationService.navigateToProfileFinder();
  };

  public executeAddDrop() {
    if (this.profile.Member) {
      this.showDropModal = true;
    } else {
      this.showAddModal = true;
    }
  }

  public async dropMember() {
    const dropSettings = {
      DropActivityTypeId: this.selectedDropType.ActivityTypeID,
      SettingBatch: null,
      AutoDrop: this.autoDrop,
    } as DropSettingsSimple;

    let valid = false;
    if (!this.autoDrop) {
      valid = true;
    } else {
      let validationResult = await this._dropMemberServcice.validateProfileDrop(this.profileId, dropSettings);
      valid = validationResult.Valid;
      if (!valid) {
        this._notificationService.error(validationResult.ResultMessage);
      }
    }

    if (valid) {
      this._dropMemberServcice.profileDropMember(this.profileId, dropSettings).then((data: DropMemberResult) => {
        if (data.Success) {
          this._notificationService.success(this._translationService.getInstant('profiles.view.drop-member.success'));
          this.loadProfile(true);
          this._observationService.profileUpdated(this.profileId);
          this.showDropModal = false;
        } else {
          this._notificationService.error(this._translationService.getInstant('profiles.view.drop-member.error'));
        }
      });
    }
  }

  public closeDropModal() {
    this.showDropModal = false;
  }

  public relateNewProfile() {
    this._relationsComponent.relateNewProfileClick();
  }

  public viewEngagementMetricsClick() {
    this._navigationService.navigateToEngagementReport(this.profileId);
  }
}
